import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_ADMIN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN_ADMIN,

  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

  // Capture 10% of transactions for performance monitoring
  tracesSampleRate: 0.1,

  // Session Replay: 10% of sessions, 100% on error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
